export default "__VITE_ASSET__D0KiQPyv__"